module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"close":"Close","confirmation":"Please confirm you want to delete this deployment by typing its name below.","danger zone":"Danger Zone","delete":"Delete Deployment"}}')
  delete Component.options._Ctor
}
